import OrderOptimizerRoadRouteParams, {
  OrderOptimizerRoadRouteParamsWaypoints,
} from "../../../../../common/services/order-optimizer/road-route/order-optimizer-road-route-params";
import OrderOptimizerDetailsWaypoint from "../../../common/types/order-optimizer-details-waypoint";
import OrderOptimizerCargoDetailsItem, {
  OrderOptimizerCargoDetailsItemOrders,
  OrderOptimizerCargoDetailsItemStepsOrdersPoints,
} from "./types/order-optimizer-cargo-details-item";

const createWaypoint = (
  order: OrderOptimizerCargoDetailsItemOrders,
  point: OrderOptimizerCargoDetailsItemStepsOrdersPoints,
): OrderOptimizerDetailsWaypoint => {
  return {
    humanId: order.humanId,
    lat: point.lat,
    lon: point.lon,
  };
};

const createWaypoints = (
  responseTransportingOrderOptimizations: OrderOptimizerCargoDetailsItem,
  hiddenOrders: number[],
): OrderOptimizerDetailsWaypoint[][] => {
  const splitWaypoints: OrderOptimizerDetailsWaypoint[][] = [];

  responseTransportingOrderOptimizations.steps.orders.forEach(
    (stepOrder, index) => {
      const order = responseTransportingOrderOptimizations.orders[index];

      if (hiddenOrders.includes(order.humanId)) {
        return;
      }

      const waypointsForOrder = stepOrder.points.map((point) =>
        createWaypoint(order, point),
      );
      splitWaypoints.push(waypointsForOrder);
    },
  );

  return splitWaypoints;
};

const createSearchRoutingCoordinate = (waypoint: {
  humanId: number;
  lat: number;
  lon: number;
}): OrderOptimizerRoadRouteParamsWaypoints => {
  return {
    lat: waypoint.lat,
    lon: waypoint.lon,
  };
};

const createSearchRoutingRequest = (
  waypoints: {
    humanId: number;
    lat: number;
    lon: number;
  }[],
): OrderOptimizerRoadRouteParams => {
  const request: OrderOptimizerRoadRouteParams = {
    waypoints: waypoints.map(createSearchRoutingCoordinate),
  };

  return request;
};

const orderOptimizerCargoDetailsWaypointFactory = {
  createWaypoints,
  createSearchRoutingRequest,
};

export default orderOptimizerCargoDetailsWaypointFactory;
